// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("public/img/magnifier.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.snapshots-tabs-table__count {
  margin-top: 6px;
}

.snapshots-tabs-table__top {
  background: #536584;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  padding: 8px;
}

.snapshots-tabs-table__title {
  color: #fff;
  font-size: 1.3em;
}

.snapshots-tabs-table__tr {
  border-bottom: 1px solid #e0e0e0;
  border-left: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
}

.snapshots-tabs-table__no-bottom-border {
  border-bottom: 0 !important;
}

.snapshots-tabs-table__td {
  border-right: 1px solid #eee;
}

.snapshots-tabs-table__td:last-of-type {
  border-right: 0;
}

.snapshots-tabs-table__input-text {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) 0 4px no-repeat;
  border: 0;
  outline: 0;
  width: 100%;
  min-width: 60px;
  padding: 0 0 0 18px;
  font-family: Source Sans Pro, Helvetica Neue, Helvetica, Arial, sans-serif;
  font-weight: normal;
  position: relative;
}

.snapshots-tabs-table__input-text:focus {
  border-bottom: 1px solid var(--info);
  padding-right: 0;
}

.snapshots-tabs-table__input-text:disabled {
  cursor: not-allowed;
}

.snapshots-tabs-table__pagination-page {
  border-top: 4px solid none;
  cursor: pointer;
  margin-bottom: 4px;
  margin-left: 0;
  margin-right: 0;
  padding: 0 6px;
  line-height: 26px;
}

.snapshots-tabs-table__pagination-page--active {
  border-top: 4px solid #6c7e9d;
}

.snapshots-tabs-table__pagination-arrow {
  color: #999;
  cursor: pointer;
  opacity: 1;
  margin-bottom: 1px;
  margin-left: 6px;
  margin-right: 6px;
  font-size: 1.5em;
}

.snapshots-tabs-table__pagination-arrow--disabled {
  cursor: normal;
  opacity: .5;
}

.snapshots-tabs-table__pagination-select-pagination {
  background: #f2f2f2;
  border: 0;
  width: auto;
  margin-left: 20px;
  display: inline-block;
}

.snapshots-tabs-table__pagination-foot {
  background: #f2f2f2;
  border: 1px solid #e0e0e0;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/pages/SnapshotManagement/Tabs/RunningTable/styles/Table.css","webpack://./services/frontend/app/pages/SnapshotManagement/Tabs/RunningTable/styles/Table.css"],"names":[],"mappings":"AADA;ECEE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mEAA2D;EAC3D,SAAS;EACT,UAAU;EACV,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,0EAA0E;EAC1E,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B","sourcesContent":[".snapshots-tabs-table__count {\n  margin-top: 6px;\n}\n\n.snapshots-tabs-table__top {\n  background: #536584;\n  padding: 8px;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n}\n\n.snapshots-tabs-table__title {\n  color: #fff;\n  font-size: 1.3em;\n}\n\n.snapshots-tabs-table__tr {\n  border-bottom: 1px solid #e0e0e0;\n  border-left: 1px solid #e0e0e0;\n  border-right: 1px solid #e0e0e0;\n}\n\n.snapshots-tabs-table__no-bottom-border {\n  border-bottom: 0 !important;\n}\n\n.snapshots-tabs-table__td {\n  border-right: 1px solid #eee;\n}\n\n.snapshots-tabs-table__td:last-of-type {\n    border-right: 0;\n  }\n\n.snapshots-tabs-table__input-text {\n  background: url('public/img/magnifier.png') left 4px no-repeat;\n  border: 0;\n  font-family: 'Source Sans Pro', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  font-weight: normal;\n  min-width: 60px;\n  outline: 0;\n  padding: 0;\n  position: relative;\n  width: 100%;\n  padding-left: 18px;\n}\n\n.snapshots-tabs-table__input-text:focus {\n    border-bottom: 1px solid var(--info);\n    padding-right: 0;\n  }\n\n.snapshots-tabs-table__input-text:disabled {\n    cursor: not-allowed;\n  }\n\n.snapshots-tabs-table__pagination-page {\n  border-top: 4px solid none;\n  cursor: pointer;\n  line-height: 26px;\n  margin-bottom: 4px;\n  margin-left: 0;\n  margin-right: 0;\n  padding: 0 6px;\n}\n\n.snapshots-tabs-table__pagination-page--active {\n  border-top: 4px solid #6c7e9d;\n}\n\n.snapshots-tabs-table__pagination-arrow {\n  color: #999;\n  cursor: pointer;\n  font-size: 1.5em;\n  margin-bottom: 1px;\n  margin-left: 6px;\n  margin-right: 6px;\n  opacity: 1;\n}\n\n.snapshots-tabs-table__pagination-arrow--disabled {\n  cursor: normal;\n  opacity: 0.5;\n}\n\n.snapshots-tabs-table__pagination-select-pagination {\n  display: inline-block;\n  margin-left: 20px;\n  background: #f2f2f2;\n  border: 0;\n  width: auto;\n}\n\n.snapshots-tabs-table__pagination-foot {\n  background: #f2f2f2;\n  border: 1px solid #e0e0e0;\n}\n",".snapshots-tabs-table__count {\n  margin-top: 6px;\n}\n\n.snapshots-tabs-table__top {\n  background: #536584;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  padding: 8px;\n}\n\n.snapshots-tabs-table__title {\n  color: #fff;\n  font-size: 1.3em;\n}\n\n.snapshots-tabs-table__tr {\n  border-bottom: 1px solid #e0e0e0;\n  border-left: 1px solid #e0e0e0;\n  border-right: 1px solid #e0e0e0;\n}\n\n.snapshots-tabs-table__no-bottom-border {\n  border-bottom: 0 !important;\n}\n\n.snapshots-tabs-table__td {\n  border-right: 1px solid #eee;\n}\n\n.snapshots-tabs-table__td:last-of-type {\n  border-right: 0;\n}\n\n.snapshots-tabs-table__input-text {\n  background: url(\"public/img/magnifier.png\") 0 4px no-repeat;\n  border: 0;\n  outline: 0;\n  width: 100%;\n  min-width: 60px;\n  padding: 0 0 0 18px;\n  font-family: Source Sans Pro, Helvetica Neue, Helvetica, Arial, sans-serif;\n  font-weight: normal;\n  position: relative;\n}\n\n.snapshots-tabs-table__input-text:focus {\n  border-bottom: 1px solid var(--info);\n  padding-right: 0;\n}\n\n.snapshots-tabs-table__input-text:disabled {\n  cursor: not-allowed;\n}\n\n.snapshots-tabs-table__pagination-page {\n  border-top: 4px solid none;\n  cursor: pointer;\n  margin-bottom: 4px;\n  margin-left: 0;\n  margin-right: 0;\n  padding: 0 6px;\n  line-height: 26px;\n}\n\n.snapshots-tabs-table__pagination-page--active {\n  border-top: 4px solid #6c7e9d;\n}\n\n.snapshots-tabs-table__pagination-arrow {\n  color: #999;\n  cursor: pointer;\n  opacity: 1;\n  margin-bottom: 1px;\n  margin-left: 6px;\n  margin-right: 6px;\n  font-size: 1.5em;\n}\n\n.snapshots-tabs-table__pagination-arrow--disabled {\n  cursor: normal;\n  opacity: .5;\n}\n\n.snapshots-tabs-table__pagination-select-pagination {\n  background: #f2f2f2;\n  border: 0;\n  width: auto;\n  margin-left: 20px;\n  display: inline-block;\n}\n\n.snapshots-tabs-table__pagination-foot {\n  background: #f2f2f2;\n  border: 1px solid #e0e0e0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
